module.exports = __webpack_public_path__ + "img/step2_img.e9af777f.png";